export default "dist/images/components-button-controls-ghost.a0ffb12.png";